export const MONITOREO = [
  {
    "status": "searching",
    "name": "DT682-HG5-24012",
    "ip": "10.36.1.220",
    "tipo": "LTE",
    "imei": "868371053044083",
    "primary-band": "",
    "dl-modulation": "",
    "cqi": "",
    "ri": "",
    "mcs": "",
    "rssi": "",
    "rsrp": "",
    "rsrq": "",
    "sinr": "",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "",
    "enb-id": "",
    "phy-cellid": ""
  },
  {
    "status": "connected",
    "name": "DT667-HG5-24013",
    "ip": "10.36.1.221",
    "tipo": "LTE",
    "imei": "868371053043838",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 4",
    "dl-modulation": "16qam",
    "cqi": 1,
    "ri": 1,
    "mcs": 11,
    "rssi": "-68dBm",
    "rsrp": "-91dBm",
    "rsrq": "-6dB",
    "sinr": "16dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "47m25s",
    "enb-id": 0,
    "phy-cellid": 4
  },
  {
    "status": "connected",
    "name": "DT632-HG5-24020",
    "ip": "10.36.1.222",
    "tipo": "LTE",
    "imei": "868371052875479",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 4",
    "dl-modulation": "16qam",
    "cqi": 7,
    "ri": 1,
    "mcs": 13,
    "rssi": "-69dBm",
    "rsrp": "-94dBm",
    "rsrq": "-8dB",
    "sinr": "11dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "46m51s",
    "enb-id": 0,
    "phy-cellid": 4
  },
  {
    "status": "connected",
    "name": "ES035-HG4-23015",
    "ip": "10.36.1.224",
    "tipo": "LTE",
    "imei": "868371053045478",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 1",
    "dl-modulation": "qpsk",
    "cqi": 8,
    "ri": 1,
    "mcs": 1,
    "rssi": "-56dBm",
    "rsrp": "-80dBm",
    "rsrq": "-7dB",
    "sinr": "14dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "11h19m30s",
    "enb-id": 0,
    "phy-cellid": 1
  },
  {
    "status": "connected",
    "name": "ES030",
    "ip": "10.36.1.227",
    "tipo": "LTE",
    "imei": "868371053046047",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 1",
    "dl-modulation": "16qam",
    "cqi": 7,
    "ri": 1,
    "mcs": 16,
    "rssi": "-56dBm",
    "rsrp": "-82dBm",
    "rsrq": "-9dB",
    "sinr": "12dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "1d4h17m22s",
    "enb-id": 0,
    "phy-cellid": 1
  },
  {
    "status": "searching",
    "name": "DT668-HG5-24019",
    "ip": "10.36.1.228",
    "tipo": "LTE",
    "imei": "868371052888118",
    "primary-band": "",
    "dl-modulation": "",
    "cqi": "",
    "ri": "",
    "mcs": "",
    "rssi": "",
    "rsrp": "",
    "rsrq": "",
    "sinr": "",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "",
    "enb-id": "",
    "phy-cellid": ""
  },
  {
    "status": "connected",
    "name": "GW02-HG5-24009",
    "ip": "10.36.1.231",
    "tipo": "LTE",
    "imei": "868371053083325",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 4",
    "dl-modulation": "16qam",
    "cqi": 15,
    "ri": 1,
    "mcs": 10,
    "rssi": "-25dBm",
    "rsrp": "-48dBm",
    "rsrq": "-6dB",
    "sinr": "21dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "2h33m37s",
    "enb-id": 0,
    "phy-cellid": 4
  },
  {
    "status": "connected",
    "name": "DT669-HG5-24021",
    "ip": "10.36.1.252",
    "tipo": "LTE",
    "imei": "868371053045387",
    "primary-band": "B28@10Mhz earfcn: 9260 phy-cellid: 4",
    "dl-modulation": "qpsk",
    "cqi": 1,
    "ri": 1,
    "mcs": 7,
    "rssi": "-59dBm",
    "rsrp": "-82dBm",
    "rsrq": "-6dB",
    "sinr": "17dB",
    "apn-profiles": "default",
    "network-mode": "3g,lte,5g",
    "session-uptime": "1h31m8s",
    "enb-id": 0,
    "phy-cellid": 4
  }
]

